<template>
  <v-container fluid>
    <div v-if="loading">
      <div class="mb-3">
        <v-skeleton-loader type="list-item-two-line"></v-skeleton-loader>
      </div>
      <v-skeleton-loader type="table"></v-skeleton-loader>
    </div>
    <div v-else>
      <div class="text-h1 mb-4">
        <v-row >
          <v-col cols="12">
            <div class="text-h2 text-primary mb-0">
              Relatórios / Usuários
            </div>
          </v-col>
         <v-col cols="11" class="pt-0">
            <v-row no-gutters>
              <v-col xl="2" class="pt-1" v-if="nivelUsuarioApelido === 'M'">
                <v-autocomplete
                  :menu-props="{ offsetY: true}"
                  :items="distribuidores"
                  label="Distribuidor"
                  append-icon="expand_more"
                  v-model="distribuidor"
                  hide-details=""
                  :loading="loading || loadingDistribuidores"
                  :disabled="loading || loadingDistribuidores"
                  outlined
                  clearable
                  @click:clear="() => {
                    this.integrador = null
                    this.integradores = []
                  }"
                  clear-icon="close"
                  @change="() => {
                    this.integrador = null
                    this.integradores = []
                    getIntegradores(distribuidor)
                  }"
                ></v-autocomplete>
              </v-col>
              <v-col xl="2" class="pt-1" v-if="nivelUsuarioApelido === 'M' || nivelUsuarioApelido === 'D'">
                <v-autocomplete
                  :menu-props="{ offsetY: true}"
                  :class="nivelUsuarioApelido !== 'D' ? 'ml-3' : ''"
                  :items="integradores"
                  label="Integrador"
                  append-icon="expand_more"
                  v-model="integrador"
                  hide-details=""
                  :loading="loading || loadingIntegradores"
                  :disabled="loading || loadingIntegradores"
                  outlined
                  clearable
                  clear-icon="close"
                ></v-autocomplete>
              </v-col>
              <v-col xl="2" class="pt-1">
                <v-autocomplete
                  :menu-props="{ offsetY: true}"
                  :class="nivelUsuarioApelido !== 'I' ? 'ml-3' : ''"
                  :items="grupos"
                  label="Grupo"
                  append-icon="expand_more"
                  v-model="grupo"
                  hide-details=""
                  :loading="loading || loadingGrupos"
                  :disabled="loading || loadingGrupos"
                  outlined
                  clearable
                  clear-icon="close"
                ></v-autocomplete>
              </v-col>
              <v-col xl="2" class="pt-1">
                <v-autocomplete
                  :menu-props="{ offsetY: true}"
                  class="ml-3"
                  :items="modulos"
                  label="Módulo"
                  append-icon="expand_more"
                  v-model="modulo"
                  hide-details=""
                  :loading="loading || loadingModulos"
                  :disabled="loading || loadingModulos"
                  outlined
                  clearable
                  clear-icon="close"
                ></v-autocomplete>
              </v-col>
              <v-col xl="1" class="pt-1">
                <div class="ml-3 search_btn">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn color="ui-btn-inherit ui-search_btn" v-bind="attrs" v-on="on" :loading="loadingSearch" :disabled="loadingSearch" @click="applyFilter()">
                        <v-icon>search</v-icon>
                      </v-btn>
                    </template>
                    <span>Filtrar</span>
                  </v-tooltip>
                </div>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="1" class="pt-0 text-center">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="ui-btn-inherit mt-1" v-bind="attrs" v-on="on" @click="print()">
                  <v-icon large color="primary" size="10">
                    print
                  </v-icon>
                </v-btn>
              </template>
              <span>Imprimir relatório</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </div>
      <div id="print" v-if="dados && dados.length > 0">
        <!-- <div class="impressao__footer impressao__footer_hr text-center">
          <p class="impressao__footer_text">Emitido através da plataforma <b>SolarMaker</b> em {{$root.Formatter.formatDate(datetime, 'L')}} {{$root.Formatter.formatDate(datetime, 'HH:mm:ss')}}</p>
        </div> -->
        <div class="impressao__header text-center">
          <img v-if="!user.logo_sistema" class="impressao__logo" src="@assets/img/logo.png" alt="SolarMaker">
          <img v-else class="impressao__logo" :src="user.logo_sistema" alt="Logo sistema">
          <p>Relatório de Usuários</p>
        </div>
        <div v-for="(distribuidor, indexDis) in dados" :key="indexDis" class="mb-3" v-show="distribuidor">
          <div class="text-h3 text-primary impressao__distribuidor">
            {{distribuidor.dis_nome}}
          </div>
          <div v-for="(integrador, indexInt) in distribuidor.integradores" :key="indexInt" class="mb-5" v-show="integrador">
            <div class="text-h7 text-primary mt-5 mb-2 impressao__integrador">
              Integrador {{integrador.int_nome}}
            </div>
            <v-simple-table class="base_table" v-if="integrador.usuarios.length">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">
                      Login
                    </th>
                    <th class="text-center">
                      Nome
                    </th>
                    <th class="text-center">
                      E-mail
                    </th>
                    <th class="text-center">
                      Grupo
                    </th>
                    <th class="text-center d-printer-none">
                      Módulos
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in integrador.usuarios" :key="index">
                    <td class="text-left">
                      {{item.usu_apelido}}
                    </td>
                    <td class="text-center">{{item.usu_nome}}</td>
                    <td class="text-center">{{item.usu_email}}</td>
                    <td class="text-center">{{item.grupo.gru_nome}}</td>
                    <td class="text-center usuario_modulos pb-2 pt-2 d-printer-none">
                      <span v-for="(modulo, indexModulo) in item.grupo.modulos" :key="indexModulo">
                        {{modulo.mod_nome}}{{item.grupo.modulos.length === indexModulo + 1 ? '.' : ', '}}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <div v-else class="impressao__sem_dados">
              Nenhum usuário encontrado.
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        Nenhum dado encontrado.
      </div>
    </div>
  </v-container>
</template>

<script>
import Api from '@API'
import Printd from 'printd'
export default {
  data () {
    return {
      user: null,
      search: '',
      loading: true,
      loadingSearch: false,
      integrador: null,
      integradores: [],
      loadingIntegradores: false,
      distribuidor: null,
      distribuidores: [],
      loadingDistribuidores: false,
      modulo: null,
      modulos: [],
      loadingModulos: false,
      grupo: null,
      grupos: [],
      loadingGrupos: false,
      nivelUsuarioApelido: '',
      datetime: new Date(),
      dados: [],
      labels: [
        { key: 'thisDay', label: 'Hoje', value: 'day' },
        { key: 'last30Days', label: 'Últimos 30 dias', value: 30 },
        { key: 'thisMonth', label: 'Este mês', value: 'month' },
        { key: 'lastMonth', label: 'Mês passado', value: '-month' },
        { key: 'thisYear', label: 'Este ano', value: 'year' },
        { key: 'lastYear', label: 'Último ano', value: '-year' }
      ]
    }
  },
  methods: {
    async print () {
      const d = new Printd()
      let styles = [
        `
          body {
            overflow: hidden;
            font-family: "Arial", sans-serif !important;
          }
          p, strong, b, small, span, q, i, td {
            color: #000!important;
            font-size: .85rem!important;
            line-height: .9rem!important;
            word-break: keep-all!important;
          }
          .v-application {
            font-family: "Arial", sans-serif !important;
          }
        `,
        `
          .impressao__header {
            width: 100%;
            text-align: center;
            color: #000!important;
          }
          .impressao__header p {
            margin-top: 1em;
            font-size: 14px;
            font-weight: bold;
          }
          .impressao__logo {
            max-width: 15%;
            color: #000!important;
          }
          .impressao__footer {
            top : 0;
            position: fixed;
            width: 100%;
            display: none;
          }
          .impressao__footer_text {
            text-align: center;
            color: #d0d0d0;
            font-size: 11px;
            padding-top: 5px;
          }
          .impressao__footer_hr {
            margin-bottom: 10px;
          }
          .impressao__break {
            page-break-after: always;
          }
          .impressao__footer, .impressao__footer-space {
            height: 2em;
          }
          .impressao__distribuidor {
            font-size: 15px;
          }
          .impressao__integrador {
            font-size: 14px;
            padding-top: 2em;
            padding-bottom: 1em;
          }
          .impressao__sem_dados {
            font-size: 14px;
            padding-left: 15px;
          }
          #print .text-h3 {
            font-weight: bold;
            font-size: 13px;
            margin-top: 3em;
          }
          @media screen {
            .impressao__footer {
              display: none;
            }
          }
          @media print {
            thead {display: table-header-group;}
            tfoot {display: table-footer-group;}
            button {display: none;}
            body {margin: 0;}
            * {
              color: #000!important;
            }
            .v-data-table {
              width: 100%;
            }
            .v-data-table th {
              border-bottom: thin solid rgba(0,0,0,.12)!important;
              min-width: 4em;
            }
            .v-data-table td {
              border-bottom: thin solid rgba(0,0,0,.12)!important;
              max-width: 20em;
            }
            .v-data-table .text-center {
              text-align: center;
            }
            .d-printer-none {
              display: none;
            }
            p {
              widows: 3;
            }

            // .impressao__footer {
            //   display: block;
            // }
            .impressao__header {
              display: block;
              width: 100%;
              color: #000!important;
            }
          }
          @page {
            size: A4 landscape !important;
            margin: 12mm;
          }
        `,
        'https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900',
        'https://cdn.jsdelivr.net/npm/vuetify@2.x/dist/vuetify.min.css'
      ]

      let documento = document.getElementById('print')
      await d.print(documento, styles)
    },
    applyFilter () {
      this.loading = true
      let query = Object.assign({},
        this.distribuidor ? { distribuidor: this.distribuidor } : '',
        this.integrador ? { integrador: this.integrador } : '',
        this.grupo ? { grupo: this.grupo } : '',
        this.modulo ? { modulo: this.modulo } : ''
      )
      this.$router.replace({name: 'RelatoriosUsuarios', query: query}).catch(() => {})

      this.loadFunctions()
    },
    loadFunctions () {
      let endpoint = '?filtro='

      if (this.distribuidor) {
        endpoint += '&distribuidor=' + this.distribuidor
      }
      if (this.integrador) {
        endpoint += '&integrador=' + this.integrador
      }
      if (this.grupo) {
        endpoint += '&grupo=' + this.grupo
      }
      if (this.modulo) {
        endpoint += '&modulo=' + this.modulo
      }
      this.getDados(endpoint)
    },
    loadContent () {
      let filters = this.$route.query
      if (filters.distribuidor) this.distribuidor = filters.distribuidor
      if (filters.integrador) this.integrador = filters.integrador
      if (filters.grupo) this.grupo = filters.grupo
      if (filters.modulo) this.modulo = filters.modulo
      this.getDistribuidores()
      this.getIntegradores(this.distribuidor)
      this.getModules()
      this.getGroups()
      this.loadFunctions(this.de, this.ate)
    },
    async getModules () {
      this.loadingModulos = true
      await Api.get('modulos')
        .then(res => {
          var arrayModulos = []
          res.data.map(mod => {
            arrayModulos.push({
              'text': mod.mod_nome,
              'value': mod.uuid_mod_id
            })
          })
          this.modulos = arrayModulos
          this.loadingModulos = false
        })
        .catch(err => {
          this.loadingModulos = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os módulos!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async getGroups () {
      this.loadingGrupos = true
      await Api.get('grupos')
        .then(res => {
          if (res.data && res.data.length > 0) {
            let info = []
            res.data.map(item => {
              info.push({
                'text': item.gru_nome,
                'value': item.uuid_gru_id
              })
            })

            this.grupos = info
          }
          this.loadingGrupos = false
        })
        .catch(err => {
          this.loadingGrupos = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os grupos!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async getDistribuidores () {
      this.loadingDistribuidores = true
      await Api.get('distribuidores')
        .then(res => {
          var arrayDists = []
          res.data.map(dist => {
            arrayDists.push({
              'text': dist.dis_nome,
              'value': dist.uuid_dis_id
            })
          })
          this.distribuidores = arrayDists
          this.loadingDistribuidores = false
        })
        .catch(err => {
          this.loadingDistribuidores = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os distribuidores!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async getIntegradores (distribuidor = null) {
      this.loadingIntegradores = true
      let url = 'integradores'

      if (distribuidor) {
        url = `integradores/distribuidor/${distribuidor}`
      }
      await Api.get(url)
        .then(res => {
          var arrayInt = []
          res.data.map(int => {
            arrayInt.push({
              'text': int.int_nome,
              'value': int.uuid_int_id
            })
          })
          this.integradores = arrayInt
          this.loadingIntegradores = false
        })
        .catch(err => {
          this.loadingIntegradores = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os integradores!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async getDados (endpoint) {
      this.loading = true
      await Api.get('relatorios/usuarios' + endpoint)
        .then(res => {
          this.dados = res.data
          console.log('Relatórios de Usuários ==>', res.data)
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os relatórios de Usuários!',
            color: 'error'
          })
          console.log(err)
        })
    },
    updateData () {
      if (JSON.parse(localStorage.getItem('user')) !== null && !this.user) {
        this.user = JSON.parse(localStorage.getItem('user'))
        if (this.user.fk_gru_id_grupo) {
          this.nivelUsuarioApelido = 'M'
        }
        if (this.user.fk_dis_id_distribuidor) {
          this.nivelUsuarioApelido = 'D'
        }
        if (this.user.fk_int_id_integrador) {
          this.nivelUsuarioApelido = 'I'
        }
      }
    }
  },
  updated () {
    this.updateData()
  },
  created () {
    this.updateData()
    this.loadContent()
  }
}
</script>

<style lang="scss" scoped>
@import "@scss/_variables.scss";
@import "@scss/_ui.scss";
.item_lista {
  border: 1px $primary solid;
  border-left-width: 10px;
  height: 100%;
  padding: 15px;
  .text-h3 {
    margin-bottom: 25px;
    position: relative;
    &:before {
      background: $primary;
      bottom: -10px;
      content: '';
      height: 1px;
      left: -15px;
      position: absolute;
      width: calc(100% + 30px);
    }
  }
  @media (max-width: 767px){}
}
.impressao__footer {
  bottom: 0;
  position: fixed;
  width: 100%;
  display: none;
}
.impressao__footer_text {
  color: #d0d0d0;
  font-size: 11px;
  padding-top: 5px;
}
.impressao__footer_hr {
  margin-bottom: 10px;
}
.impressao__header {
  width: 100%;
  display: none;
}
.usuario_modulos {
  width: 50%;
}
</style>



// WEBPACK FOOTER //
// src/pages/relatorios/operacional/Usuarios.vue